import WidgetCard from "@/components/cards/widget-card";
import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { customerListData } from "@/data/crm-dashboard-data";
import cn from "@/utils/class-names";
import { Link } from "react-router-dom";
import { Button } from "rizzui";
import { defaultColumns } from "./column";

export type CustomerListDataType = (typeof customerListData)[0];

export default function CustomerList({ className }: { className?: string }) {
    const { table } = useTanStackTable<CustomerListDataType>({
        tableData: customerListData,
        columnConfig: defaultColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 5,
                },
            },
            enableSorting: false,
            enableColumnResizing: false,
        },
    });

    return (
        <WidgetCard
            title="Customer list"
            className={cn("@container", className)}
            headerClassName="items-center mb-1 @xl:mb-4"
            action={
                <Link to={"#"}>
                    <Button
                        as="span"
                        variant="text"
                        className="h-auto p-0 underline"
                    >
                        View All
                    </Button>
                </Link>
            }
        >
            <Table
                table={table}
                variant="minimal"
                classNames={{
                    container: "[&>table>thead>tr>th]:whitespace-nowrap",
                }}
            />
        </WidgetCard>
    );
}
